import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getExpenses, deleteExpense, updateExpensesPagination } from '../../../store/actions/expense/expense_action';
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../../ui_components/table_pagination';
import { REACT_ROUTES } from '../../../constants/react_routes';
import ActionsComponent from '../../ui_components/actions_component';
import { roundNumber } from '../../../utils/helper_functions';
import history from '../../../services/history';
import { format } from 'date-fns';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    }
}));

const ExpensesTable = ({ expenses: { collection, totalCount, page, rowsPerPage, filters } }) => {
    const { paper, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getExpenses({ page, rowsPerPage, filters }));
        }
    }, []);

    const handleClick = (uuid) => {
        history.push(`${REACT_ROUTES.EXPENSE}/${uuid}`);
    }

    const handleDeleteExpense = (uuid) => {
        dispatch(deleteExpense(uuid))
            .then(() => dispatch(getExpenses({ page, rowsPerPage, filters })));
    }

    return (
        <Paper className={paper}>
            <Table aria-label="table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Tip</TableCell>
                        <TableCell align="center">Iznos</TableCell>
                        <TableCell align="center">Datum</TableCell>
                        <TableCell align="right">Akcije</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {collection.map(({ uuid, expenseType, amount, date }, index) =>
                        <TableRow hover key={index} className={tableRow}>
                            <TableCell align="center">{ expenseType?.name }</TableCell>
                            <TableCell align="center">{ roundNumber(amount) }</TableCell>
                            <TableCell align="center">{ format(new Date(date), 'dd.MM.yyyy') }</TableCell>
                            <TableCell align="right">
                                <ActionsComponent
                                    handleEdit={() => handleClick(uuid)}
                                    handleDelete={() => handleDeleteExpense(uuid)}
                                    deletable={true}
                                    label="trošak"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TablePagination
                    page={page}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    filters={filters}
                    updatePagination={updateExpensesPagination}
                 />
            </Table>
        </Paper>
    )
}

ExpensesTable.propTypes = {
    expenses: PropTypes.object
}

const mapStateToProps = (state) => ({
    expenses: state.expenses
});

export default connect(mapStateToProps)(ExpensesTable);
